/*  TODO: Start separating data fetching based on data type (i.e. company, application, listing, etc.)  */
export default {
  FETCH_USERS_REQUEST: "FETCH_USERS_REQUEST",
  FETCH_USERS_SUCCESS: "FETCH_USERS_SUCCESS",
  FETCH_USERS_ERROR: "FETCH_USERS_ERROR"
}